<template>
  <el-upload 
    action 
    :accept="acceptType" 
    drag
    :class="['uploader', {'my-custom-drag-btn': !drag}, {'disabled': disabled}]"
    multiple 
    ref="uploader"
    :disabled="disabled"
    :show-file-list="false"
    :http-request="e => uploadHanlder(e)"
    :beforeUpload="file => beforeUpload(file)"
    @drop.native="e => beforeUpload(e.dataTransfer.files[0])"
    >
    <slot :loading="loading">
      <template v-if="drag">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text" v-if="!loading">
          <span v-if="text" v-html="text"></span>
          <template v-else>Drag the file here, or <em>click to upload file</em></template>
        </div>
        <div class="el-upload__text" v-else>loading...</div>
        <div class="el-upload__tip" slot="tip" v-show="showTip">Only {{acceptType}} files, and less than {{size}}</div>
      </template>
      <el-button 
        size="small" 
        :loading="loading"
        :disabled="disabled" 
        v-else>
        <span v-if="text" v-html="text"></span>
        <template v-else><i class="el-icon-upload" /> 上传文件</template>
      </el-button>
    </slot>
  </el-upload>
</template>

<script>
import { FileUpload } from '@/api/index.js'
import { mimeType } from '@/utils/json.js'
export default {
  name: 'default',
  data () {
    return {
      file: null,
      multLoading: [],
      ts: null
    }
  },
  props: {
    drag: Boolean,
    disabled: Boolean,
    accept: {
      type: String,
      required: false,
      default: '',
    },
    size: {
      type: String | Number,
      required: false,
      default: '20M',
    },
    showTip: {
      type: Boolean,
      default: false,
      required: false
    },
    text: {
      type: String,
      default: null,
      required: false
    }
  },
  computed: {
    acceptType(){
      let accept = this.accept;
      let result = null;
      if(typeof accept === 'string')
        result = accept;
      else if(accept instanceof Array)
        result = accept.join(',')
      else try{result = JSON.stringify(accept)}catch(e){}
      if(result) result = result.toLowerCase();
      return result;
    },
    acceptMimeType(){
      let accepts = this.acceptType.split(',');
      let mimes = accepts.map(item => mimeType[item]).filter(item => item)
      let result = mimes.filter(item => !(item instanceof Array));
      let array = mimes.filter(item => item instanceof Array);
      for(let i in array) result = [...result, ...array[i]];
      return result;
    },
    loading(){
      return !this.multLoading || !this.multLoading.length
      ? false
      : true
    }
  },
  methods: {
    uploadHanlder({file}){
      this.multLoading.push('loading');
      let formData = new FormData();
      formData.append('file', file);
      formData.append('ThrowError', true);
      FileUpload(formData).then(res => {
        this.$emit('callback', res);
        this.$refs.uploader.clearFiles();
      }).catch(() => {
        this.$refs.uploader.clearFiles();
      }).finally(() => {
        this.multLoading.splice(-1);
      })
    },
    beforeUpload(file){
      let ts = new Date().getTime();
      if(this.ts && ts - this.ts <= 50) return;
      this.ts = ts;
      //验证文件大小
      let sizeResult = this.checkFileSize(file.size)
      if(sizeResult){
        this.$message.warning(sizeResult);
        return false;
      }
      let acceptResult = this.checkFileType(file.type);
      if(acceptResult){
        this.$message.warning(acceptResult);
        return false;
      }
      return true;
    },
    checkFileSize(size){
      let acceptSize = this.size;
      if(acceptSize == null || acceptSize == undefined)
        return null;
      
      acceptSize = typeof acceptSize === 'string'? 
        this.strByteTrans(acceptSize) : 
        acceptSize;
      
      if(size <= acceptSize) return;
      else return `The uploaded file cannot be larger than ${this.strByteTrans(acceptSize)}`;
    },
    strByteTrans(size, type){
      if(typeof size === 'string' || type === 'string'){
        let unit = size.replace(/[^a-zA-Z]/g, '');
        let num = size.replace(/[^0-9]/g, '');
        if(!unit) return Number(num);

        unit = unit.toLowerCase();
        let symble = ['bytes,b', 'kb,k', 'mb,m', 'gb,g', 'tb,t', 'pb,p', 'eb,e', 'zb,z', 'yb,y'];
        let index = symble.findIndex(item => item.split(',').indexOf(unit) != -1)
        if(index <= 0) return Number(num);
        else return Math.pow(1024, index) * num;
      }else if(typeof size === 'number' || type === 'number'){
        if (isNaN(size)) {
          return '';
        }
        var symbols = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var exp = Math.floor(Math.log(size)/Math.log(2));
        if (exp < 1) {
          exp = 0;
        }
        var i = Math.floor(exp / 10);
        size = size / Math.pow(2, 10 * i);

        if (size.toString().length > size.toFixed(2).toString().length) {
          size = size.toFixed(2);
        }
        return  `${size}${symbols[i]}`;
      }
    },
    checkFileType(type){
      if(!this.acceptType) return;
      if(this.acceptMimeType.indexOf(type) != -1 || !this.acceptMimeType.length) return;
      return `Only ${this.acceptType} files can be uploaded`;
    }
  }
}
</script>

<style lang="scss" scoped>
.uploader{
  &.disabled{
    opacity: .5;
    
    >>> .el-upload-dragger{
      cursor: not-allowed;
    }
  }
}
.my-custom-drag-btn{
  display: inline-block;
  margin-bottom: 0;
  vertical-align: middle;
  line-height: initial;
  
  >>> .el-upload-dragger{
    border: 0;
    width: auto;
    height: auto;
    border-radius: 0.0525rem;
    transition: box-shadow .2s;
    background-color: transparent;

    .el-button{
      margin-bottom: 0;

      .el-icon-upload{
        font-size: 1.05rem;
        margin: 0;
        line-height: 1;
        color: inherit;
      }

      .el-icon-loading{
        font-size: inherit;
        color: inherit;
        margin: 0;
        line-height: inherit;
      }

      &.is-disabled{
        .el-icon-upload{
          color: inherit;
        }
      }
    }

    &.is-dragover{
      box-shadow: 0 0 0.14rem rgba(0,0,0, .7);
      border: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Uploader.vue